<template>
  <div>{{ plaintext }}</div>
</template>

<script setup lang="ts">
import type { ParagraphTextFragment } from '#graphql-operations'

const props = defineProps<ParagraphTextFragment>()

const plaintext = computed(() => {
  if (!props.text) {
    return
  }
  const div = document.createElement('div')
  div.innerHTML = props.text
  return div.textContent || div.innerText || ''
})
</script>
